<template>
  <label
    :class="cn('relative inline-flex items-center justify-center align-middle select-none shrink-0 leading-none h-[18px] w-[18px]', disabled ? 'cursor-not-allowed' : 'cursor-pointer')"
    @click.stop
  >
    <input
      type="checkbox"
      class="peer opacity-0 absolute w-5 h-5 z-10"
      :class="{
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled
      }"
      :disabled="disabled"
      :checked="checked"
      @change="$emit('change', $event.target.checked, $event)"
    >
    <span
      :class="cn(
        'w-[18px] h-[18px] shrink-0 box-border rounded-[5px] border flex items-center justify-center leading-none transition-all duration-150',
        disabled
          ? (checked || indeterminate)
            ? 'bg-[#E5E5E5] border-[#D4D4D4] text-[#737373]'
            : 'bg-[#F5F5F5] border-[#E5E5E5]'
          : (checked || indeterminate)
            ? 'bg-[#FB6514] border-[#FB6514] text-white shadow-xs peer-focus-visible:ring-2 peer-focus-visible:ring-[#FB6514]/30'
            : 'bg-white border-[#D4D4D4] peer-hover:border-[#FB6514] peer-focus-visible:ring-2 peer-focus-visible:ring-[#FB6514]/30'
      )"
    >
      <svg
        v-if="checked"
        class="w-[12px] h-[12px] shrink-0 block stroke-[3.5]"
        :class="disabled ? 'text-[#737373]' : 'text-white'"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 13l4 4L19 7"
        />
      </svg>
      <svg
        v-else-if="indeterminate"
        class="w-[12px] h-[12px] shrink-0 block stroke-[3.5]"
        :class="disabled ? 'text-[#737373]' : 'text-white'"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M18 12H6"
        />
      </svg>
    </span>
  </label>
</template>

<script>
import { cn } from '../utils'

export default {
  name: 'TableCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cn,
  },
}
</script>
